export default
{
    // Basic
    black: '#000000',
    black_near: '#1a1919',
    gray_darker: '#010b27',
    gray_dark: '#535764',
    gray_mid: '#787e90',
    gray: '#a5a9b5',
    gray_light: '#d8d8d8',
    gray_lighter: '#f5f2f0',
    white_near: '#f9f7f5',
    white: '#ffffff',

    // Brand Gold
    brand_gold: '#c79268'
}



// WEBPACK FOOTER //
// ./src/scripts/constants/colors.js